<main>
  <header>
    <h1>Request a Credit Line</h1>
    <h2>Please indicate your preferred credit line. You may leave this blank if undecided.</h2>
  </header>

  <form class="credit-line-form" [formGroup]="form" (ngSubmit)="continue()">
    <div class="field">
      <label for="credit-line-estimate">Credit Line Estimate (optional)</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input
          matInput
          id="credit-line-estimate"
          placeholder="$50,000"
          currencyMask
          [options]="{ prefix: '$ ', thousands: ',', decimal: '.', precision: 0}"
          formControlName="requestedAmount"
        />
        <mat-error *ngIf="form.get('requestedAmount')?.hasError('min')">
          Minimum credit line is $5,000
        </mat-error>
        <mat-error *ngIf="form.get('requestedAmount')?.hasError('max')">
          Maximum credit line is $250,000
        </mat-error>
      </mat-form-field>
      <p class="field-info">You may enter a minimum of $5,000 and a maximum of $250,000</p>
    </div>

    <app-form-actions
      [isFormInvalid]="form.invalid"
      (continue)="continue()"
      (back)="goBack()"
    >
    </app-form-actions>
  </form>

  <p class="additional-info">
    A business line of credit gives you flexible access to funds. You can draw
    what you need, when you need it, up to your approved limit. As you repay,
    your funds become available again.
  </p>
</main>
